import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-admindown",
  "use": "icon-admindown-usage",
  "viewBox": "0 0 10 5",
  "content": "<symbol viewBox=\"0 0 10 5\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-admindown\">\n<path d=\"M4.6425 4.6875L4.9925 4.9975L9.8525 0.7475C10.0425 0.5775 10.0425 0.2975 9.8525 0.1275C9.6625 -0.0425 9.3425 -0.0425 9.1525 0.1275L4.9925 3.7575L0.8425 0.1275C0.6525 -0.0425 0.3325 -0.0425 0.1425 0.1275C-0.0475 0.2975 -0.0475 0.5775 0.1425 0.7475L4.6225 4.6775L4.6425 4.6875Z\" fill=\"\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol